<div class="a-header-edit-container">
    <i class="fa fa-chevron-left"></i>
    <span>{{title}}</span>
    <i class="fa fa-chevron-right"></i>
</div>